<div>
	<div class="row">
		<div class="col"></div>
		<div class="col-auto">
			<button type="button" class="btn btn-primary" [routerLink]="['/Asset/assetmaster/add/',0]"
				[disabled]="isDisabled">
				<i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Add Asset':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Asset Master
		</div>
		<div class="card-body p-1">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th>Image</th>
						<th>Asset Group</th>
						<th>Asset Code</th>
						<th>Asset Name</th>
						<th>Description</th>
						<th style="width: 5px;">Action</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td>
							<a [href]="Link(TableData['Image'])" target="_blank"><img class="Image"
									[src]="Link(TableData['Image'])" /></a>
						</td>
						<td>{{TableData['AssetGroupName']}}</td>
						<td>{{TableData['AssetMasterCode']}}</td>
						<td>{{TableData['AssetMasterName']}}</td>
						<td>{{TableData['Description']}}</td>
						<td style="width: 5px;">
							<div class="text-center"><i
									[routerLink]="['/Asset/assetmaster/add/',TableData['ESS_AssetMasterId']]"
									class="bi bi-pencil-square text-warning"></i></div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>